<template>
  <div class="idp">
    <TnIcon
      :name="idp.logoIcon"
      size="l"
      class="idp-logo"
      :aria-label="`${idp.displayName} logo`"
    />
    <a :href="url" class="idp-name">{{ idp.displayName }}</a>
    <TnIcon name="chevron-right" class="idp-chevron" />
  </div>
</template>

<script setup lang="ts">
import { TnIcon } from '@telenornorgeinternal/telegrafen-vue3-core';

import type { Idp } from '@/types';

defineProps<{ idp: Idp; url: string }>();
</script>

<style scoped>
.idp {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 96px;
  margin-block: 16px;
  border-start-end-radius: 8px;
  border-end-end-radius: 8px;
  background-color: #f5f5f5;
}

.idp-logo {
  /* Keeps the same 1:3 column split as the previous <img>. TnIcon sizes itself
     via the `size` prop, so the height cap is no longer needed. */
  flex: 1;
  display: flex;
  justify-content: center;
  margin-inline: 8px;
  padding-left: 16px;
}

.idp-name {
  flex: 3;
  font-size: 18px;
  line-height: 28px;
  color: #000;
  text-decoration: none;
}

.idp-chevron {
  margin-right: 16px;
}
</style>
